export default {
  brand: 'CrypPay',
  transferHint: 'Por favor transfiere a la siguiente dirección',
  rechargeAmount: 'Monto de recarga',
  rechargeAddress: 'Dirección de depósito',
  scanTip: 'Escanea el código QR con tu billetera para pagar',
  copy: 'Copiar',
  copied: 'Copiado',
  copyFail: 'Error al copiar',
  networkFee: 'Comisión de red',
  eta: 'Tiempo estimado de llegada',
  etaVal: '~ 15 - 30 min',
  actualArrival: 'Recibirás',
  noticeTitle: 'Importante',
  notice1: 'Por favor envía únicamente a la dirección o código QR mostrado en esta página. Los fondos enviados a direcciones incorrectas no pueden recuperarse.',
  notice2: 'El monto debe ser exactamente {amount} {coin}. Si no coincide, no se acreditará automáticamente.',
  notice3: 'Espera la confirmación de la blockchain (normalmente 1 confirmación).',
  notice4: 'Las transacciones en cadena son irreversibles. Las pérdidas por error del usuario son responsabilidad del usuario.',
  selectLang: 'Seleccionar idioma',
  pending: 'Pendiente',
  paid: 'Pagado',
  timeout: 'Expirado',
  orderNo: 'Pedido',
  loading: 'Cargando…',
  paramError: 'Parámetros del enlace incompletos',
  initFail: 'Error al crear el pedido',
  paidSuccess: 'Pago exitoso',
  timedOut: 'El pedido expiró, por favor inténtalo de nuevo'
}